module.exports = __webpack_public_path__ + "img/btn_close2.84adc88f.png";